import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material"

interface RotatePatDialogProps {
  open: boolean
  subject: string
  onClose: () => void
  onConfirm: () => void
}

export default function RotatePatDialog({ open, subject, onClose, onConfirm }: RotatePatDialogProps) {
  return <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle>Rotate token</DialogTitle>
    <DialogContent>
      <Alert severity="warning">
        Rotating <strong>{subject || "token"}</strong> will invalidate the current secret immediately. Any integrations using it must be updated with the new value.
      </Alert>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="secondary">Cancel</Button>
      <Button onClick={onConfirm} color="error" variant="contained">Rotate token</Button>
    </DialogActions>
  </Dialog>
}
